// extracted by mini-css-extract-plugin
export default {"knockedDown":"creature-sheet_knockedDown__2EThW","dead":"creature-sheet_dead__O4UJp","deadBlock":"creature-sheet_deadBlock__g-dKe"};